var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var Overlay = function (_a) {
    var isOpen = _a.isOpen, onClick = _a.onClick;
    if (!isOpen)
        return null;
    var handleInteraction = function (e) {
        if (e.type === 'click' ||
            (e.type === 'keydown' && ('key' in e && (e.key === 'Enter' || e.key === ' ')))) {
            e.preventDefault();
            onClick === null || onClick === void 0 ? void 0 : onClick();
        }
    };
    var sharedProps = {
        role: 'button',
        tabIndex: 0,
        'aria-label': 'Fechar overlay',
        onClick: handleInteraction,
        onKeyDown: handleInteraction,
        style: {
            position: 'fixed',
            backgroundColor: 'rgba(0, 0, 0, 0.0)',
            zIndex: 99999,
        },
    };
    return (_jsxs(_Fragment, { children: [_jsx("div", __assign({}, sharedProps, { className: "overlay-top", style: __assign(__assign({}, sharedProps.style), { top: 0, left: 0, width: '100%', height: 100 }) })), _jsx("div", __assign({}, sharedProps, { className: "overlay-left", style: __assign(__assign({}, sharedProps.style), { top: 100, left: 0, width: 150, height: 'calc(100vh - 100px)' }) })), _jsx("div", __assign({}, sharedProps, { className: "overlay-bottom", style: __assign(__assign({}, sharedProps.style), { bottom: 0, left: 0, width: '100%', height: 95 }) }))] }));
};
export default Overlay;
